import { render, staticRenderFns } from "./service_content.vue?vue&type=template&id=cc361212&scoped=true"
import script from "./service_content.vue?vue&type=script&lang=js"
export * from "./service_content.vue?vue&type=script&lang=js"
import style0 from "./service_content.vue?vue&type=style&index=0&id=cc361212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc361212",
  null
  
)

export default component.exports